module.exports = __webpack_public_path__ + "img/AC.17ca9f77.png";